import { render } from "./KindergartenDirectoryView.vue?vue&type=template&id=0d5b4374&scoped=true&ts=true"
import script from "./KindergartenDirectoryView.vue?vue&type=script&lang=ts"
export * from "./KindergartenDirectoryView.vue?vue&type=script&lang=ts"

import "./KindergartenDirectoryView.vue?vue&type=style&index=0&id=0d5b4374&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d5b4374"]])

export default __exports__